<template>
  <div class="mainContainer">
    <SupplierElseStatements />
  </div>
</template>

<script>
import SupplierElseStatements from '@/views/settle/supplier/supplierElseStatements/index.vue'

export default {
  components: {SupplierElseStatements},
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
